import { fabric } from 'fabric';
import * as piexifjs from 'piexifjs';
import FileReader from 'promise-file-reader';

fabric.util.object.extend(fabric.Object.prototype, {
  _drawControl: function(control, ctx, methodName, left, top) {
    if (!this.isControlVisible(control)) {
      return;
    }
    const size = this.cornerSize;

    if (!this.drawIcons) {
      const size = 50;
      this.drawIcons = {
        tl: `data:image/svg+xml,%3Csvg width='25' height='25' viewBox='0 0 ${size} ${size}' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Ccircle r='${size /
          2}' fill='%23495D70' cx='${size / 2}' cy='${size /
          2}' stroke='%23fff' stroke-width='2'/%3E%3Cg transform='translate(${size / 4}, ${size /
          4})'%3E%3Cpath fill='%23fff' transform='rotate(45) translate(35, -18) scale(-1 ,1)' d='M6.35950433,18.9473617 L10.1903337,22.9252249 L8.1923306,25 L1,17.5310241 L2.99800307,15.4563383 L3.00516533,15.4639452 L8.26671132,10 L10.2647144,12.07473 L6.18053685,16.3157821 L28.8194632,16.3157821 L24.7352856,12.07473 L26.7332887,10 L31.9948347,15.4639452 L32.0019969,15.4563383 L34,17.5310241 L26.8076694,25 L24.8096663,22.9252249 L28.6404957,18.9473617 L6.35950433,18.9473617 Z'%3E%3C/path%3E%3C/g%3E%3C/svg%3E`,
        tr: `data:image/svg+xml,%3Csvg width='25' height='25' viewBox='0 0 ${size} ${size}' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Ccircle r='${size /
          2}' fill='%23495D70' cx='${size / 2}' cy='${size /
          2}' stroke='%23fff' stroke-width='2'/%3E%3Cg transform='translate(${size / 4}, ${size /
          4})'%3E%3Cpath fill='%23fff' transform='rotate(-45) translate(18, 0) scale(-1 ,1)' d='M6.35950433,18.9473617 L10.1903337,22.9252249 L8.1923306,25 L1,17.5310241 L2.99800307,15.4563383 L3.00516533,15.4639452 L8.26671132,10 L10.2647144,12.07473 L6.18053685,16.3157821 L28.8194632,16.3157821 L24.7352856,12.07473 L26.7332887,10 L31.9948347,15.4639452 L32.0019969,15.4563383 L34,17.5310241 L26.8076694,25 L24.8096663,22.9252249 L28.6404957,18.9473617 L6.35950433,18.9473617 Z'%3E%3C/path%3E%3C/g%3E%3C/svg%3E`,
        bl: `data:image/svg+xml,%3Csvg width='25' height='25' viewBox='0 0 ${size} ${size}' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Ccircle r='${size /
          2}' fill='%23495D70' cx='${size / 2}' cy='${size /
          2}' stroke='%23fff' stroke-width='2'/%3E%3Cg transform='translate(${size / 4}, ${size /
          4})'%3E%3Cpath fill='%23fff' transform='rotate(-45) translate(18, 0) scale(-1 ,1)' d='M6.35950433,18.9473617 L10.1903337,22.9252249 L8.1923306,25 L1,17.5310241 L2.99800307,15.4563383 L3.00516533,15.4639452 L8.26671132,10 L10.2647144,12.07473 L6.18053685,16.3157821 L28.8194632,16.3157821 L24.7352856,12.07473 L26.7332887,10 L31.9948347,15.4639452 L32.0019969,15.4563383 L34,17.5310241 L26.8076694,25 L24.8096663,22.9252249 L28.6404957,18.9473617 L6.35950433,18.9473617 Z'%3E%3C/path%3E%3C/g%3E%3C/svg%3E`,
        br: `data:image/svg+xml,%3Csvg width='25' height='25' viewBox='0 0 ${size} ${size}' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Ccircle r='${size /
          2}' fill='%23495D70' cx='${size / 2}' cy='${size /
          2}' stroke='%23fff' stroke-width='2'/%3E%3Cg transform='translate(${size / 4}, ${size /
          4})'%3E%3Cpath fill='%23fff' transform='rotate(45) translate(35, -18) scale(-1 ,1)' d='M6.35950433,18.9473617 L10.1903337,22.9252249 L8.1923306,25 L1,17.5310241 L2.99800307,15.4563383 L3.00516533,15.4639452 L8.26671132,10 L10.2647144,12.07473 L6.18053685,16.3157821 L28.8194632,16.3157821 L24.7352856,12.07473 L26.7332887,10 L31.9948347,15.4639452 L32.0019969,15.4563383 L34,17.5310241 L26.8076694,25 L24.8096663,22.9252249 L28.6404957,18.9473617 L6.35950433,18.9473617 Z'%3E%3C/path%3E%3C/g%3E%3C/svg%3E`,
      };
    }

    const icon = this.drawIcons[control];
    if (icon) {
      if (typeof icon === 'string') {
        //load image
        const image = new Image();
        image.onload = () => {
          this.drawIcons[control] = image;
          ctx.drawImage(image, 0, 0, 25, 25, left, top, size, size);
        };

        image.src = icon;
      } else {
        ctx.drawImage(icon, 0, 0, 25, 25, left, top, size, size);
      }
    }
  },
});

export class CanvasManager {
  protected options: fabric.ICanvasOptions = {
    backgroundColor: '#fff',
    controlsAboveOverlay: true,
    preserveObjectStacking: true,
    selection: false,
    allowTouchScrolling: true,
  };
  public canvas: fabric.Canvas;
  public element: HTMLCanvasElement;
  initialize(element: HTMLCanvasElement) {
    this.element = element;
    this.canvas = new fabric.Canvas(element, this.options);
    this.listenEvents();
  }
  protected movingObject = null;
  protected listenEvents() {
    this.canvas.on('mouse:down', () => {
      const activeObject = this.canvas.getActiveObject();

      if (activeObject) {
        this.OnObjectSelected(activeObject);
      } else {
        this.OnObjectUnSelected(activeObject);
      }
    });
    this.canvas.on('mouse:up', () => {
      const activeObject = this.canvas.getActiveObject();
      if (activeObject === this.movingObject) {
        this.movingObject = null;
        return;
      }

      this.OnObjectClicked(activeObject);
    });
    this.canvas.on('object:modified', ({ target }) => {
      const activeObject = this.canvas.getActiveObject();
      this.movingObject = activeObject;

      const event = new CustomEvent('object:modified', { detail: target });
      window.dispatchEvent(event);
    });
    this.canvas.on('selection:cleared', () => {
      window.dispatchEvent(new Event('selection:cleared'));
    });
    this.canvas.on('object:removed', ({ target }) => {
      const event = new CustomEvent('object:removed', { detail: target });
      window.dispatchEvent(event);
    });
    this.canvas.on('object:added', ({ target }) => {
      const event = new CustomEvent('object:added', { detail: target });
      window.dispatchEvent(event);
    });
    window.addEventListener('resize', this.resize.bind(this));
  }
  public get width() {
    return this.canvas.getWidth();
  }
  public get height() {
    return this.canvas.getHeight();
  }
  public selectObject(object: fabric.Object) {
    this.canvas.setActiveObject(object);
    this.OnObjectSelected(object);
    this.canvas.requestRenderAll();
  }
  public selectBackground(object: fabric.Object) {
    this.canvas.setActiveObject(object);
    this.OnBackgroundSelected(object);

    this.canvas.requestRenderAll();
  }
  protected OnObjectClicked(object: fabric.Object) {
    const event = new CustomEvent('object:clicked', { detail: object });
    window.dispatchEvent(event);
  }
  protected OnBackgroundSelected(object: fabric.Object) {
    const event = new CustomEvent('background:selected', { detail: object });
    window.dispatchEvent(event);
  }
  protected OnObjectSelected(object: fabric.Object) {
    const event = new CustomEvent('object:selected', { detail: object });
    window.dispatchEvent(event);
  }
  protected OnObjectUnSelected(object: fabric.Object) {
    const event = new CustomEvent('object:cleared', { detail: object });
    window.dispatchEvent(event);
  }
  protected resize() {
    const width = this.element.parentElement.parentElement.clientWidth;
    const height = this.element.parentElement.parentElement.clientHeight;
    if (!width || !height) return;
    if (width == this.width && height == this.height) return;
    this.canvas.setWidth(width);
    this.canvas.setHeight(height);
    this.canvas.calcOffset();
    this.canvas.requestRenderAll();
  }
  public removeObject(object: fabric.Object) {
    this.canvas.remove(object);
    this.canvas.requestRenderAll();
  }
  public async loadImageElement(src: string): Promise<HTMLImageElement> {
    return new Promise((resolve) => {
      const image = new Image();
      image.crossOrigin = 'anonymous';
      image.onload = () => resolve(image);
      image.src = src;
    });
  }
  public async loadImage(src: string | File, object?: fabric.Image): Promise<fabric.Image> {
    const file: File | string = src;
    if (typeof src != 'string') {
      src = await FileReader.readAsDataURL(src);
      const { type } = file as File;
      if (type.includes('jpg') || type.includes('jpeg')) {
        src = piexifjs.remove(src);
      }
    } else if (!/^http.*/.test(src)) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      src = `${(window as any).$store.storage}/${src}`;
    }
    const imageElement = await this.loadImageElement(src as string);

    if (object) {
      const { width, height } = object;
      object.setElement(imageElement);

      object.data = Object.assign({}, object.data, { file });

      let scale = 1;
      if (object.width > this.width) {
        scale = (width / object.width) * object.scaleX;
      }
      if (object.height > this.height) {
        scale = (height / object.height) * object.scaleY;
      }

      object.set({
        scaleX: scale,
        scaleY: scale,
      });

      object.setCoords();
      this.canvas.renderAll();

      return object;
    }

    object = new fabric.Image(imageElement);
    object.data = Object.assign({}, object.data, { file });
    if (object.width > this.width) {
      object.scaleToWidth(this.width * 0.4);
    }
    if (object.height > this.height) {
      object.scaleToHeight(this.height * 0.4);
    }

    object.setCoords();
    return object;
  }
}
